export const CREATE_SHOPPING_CART_DEMAND_REQ = {
    "channel": {
      "_id": "bo_lov_portals",
      "name": "Portals"
    },
    "offerContainer": [
      {
        "additionalAttributes": [
          {
            "name": "journeyName",
            "value": "FTTH_Demand_Request"
          }
        ],
        "cartItem": [
          {
            "action": "Add",
            "productOffering": {
              "id": "of_mobily_ftth_demand_coverage",
              "name": "FTTH Demand Coverage"
            },
            "product": {
              "productCharacteristic": [
                {
                  "name": "Demand Request Type",
                  "value": "FTTH Demand Request"
                }
              ]
            },
            "quantity": 1
          }
        ],
        "category": {
          "id": "mobily_miscellaneous",
          "name": "Miscellaneous"
        },
        "processContext": "ACQ"
      }
    ]
}

export const CREATE_SHOPPING_CART_INSTALLATION_REQ = {
  "channel": {
      "id": "bo_lov_portals",
      "name": "Portals"
  },
  "offerContainer": [
      {
          "additionalAttributes": [
              {
                  "name": "journeyName",
                  "value": "FTTH_Installation_Request"
              }
          ],
          "cartItem": [
              {
                  "action": "Add",
                  "productOffering": {
                      "id": "of_mobily_ftth_installation_request",
                      "name": "FTTH Installation Request"
                  },
                  "product": {
                      "productCharacteristic": [
                          {
                              "name": "Demand Request Type",
                              "value": "FTTH Installation Request"
                          }
                      ]
                  },
                  "quantity": 1
              }
          ],
          "category": {
              "id": "mobily_miscellaneous",
              "name": "Miscellaneous"
          },
          "processContext": "ACQ"
      }
  ]
}

export const LANGUAGE_COOKIE_NAME = "com.ibm.wps.state.preprocessors.locale.LanguageCookie";
